import { DocumentDownloadAnchor } from '@components/ui/anchor'

type Props = {
  referer: string
}

export const RequestDocBtn = ({ referer }: Props): JSX.Element => (
  <DocumentDownloadAnchor reqRef={referer}>
    <div className="lg:hover:opacity-80 lg:hover:cursor-pointer">
      <div className="flex justify-center items-center w-full h-[4.7vw] bg-primary rounded-[8px] shadow-button">
        <div className="text-[4.3vw] lg:text-[1.4vw] text-white">
          無料で資料請求
        </div>
      </div>
    </div>
  </DocumentDownloadAnchor>
)
